<template>
  <div>
    <button class="btn" @click="toggleShow">
      <span class="xianshi">
        <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/uploadimg.png" alt=""/>
        Change Profile
      </span>
    </button>
    <my-upload  
      @crop-success="cropSuccess" 
      @crop-upload-success="cropUploadSuccess"
      v-model="show" 
      :width="200" 
      :height="200" 
      img-format="png" 
      :size="size"
      langType='zh'
      :noRotate='false'
      :withCredentials='true'
      :params="params"
      field="Avatar1"
      url="/gongxujson/upload">
    </my-upload>
  </div>
</template>

<script>
import 'babel-polyfill'
import myUpload from 'vue-image-crop-upload';
import { mapState } from 'vuex'
import { reqMyTopimgUpdate } from "../../../api";
export default {
  components:{
    "my-upload":myUpload
  },
  data(){
    return{
      imgDataUrl:'',
      show:false,
      size:2.1,
      params:{},
    }
  },
  methods:{
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgDataUrl) {//截取完成之后
      this.params={'field':imgDataUrl}
    },
    //上传成功回调
    async cropUploadSuccess(jsonData){
      const response = await reqMyTopimgUpdate(jsonData.msg)
      if (response.code*1==3) {
        this.success(this,"Updated Successfully")
        this.imgDataUrl = jsonData.msg
        let {user} = this
        user.img = jsonData.msg
        this.$store.dispatch("userInformation",user)
        this.show = false
      }else{
        this.err(this,"Timeout, please try...")
      }
    },
    //上传失败回调
    // cropUploadFail(status, field){
    //   console.log('-------- upload fail --------');
    //   console.log('上传失败状态'+ status);
    //   console.log('field: ' + field);
    // }
  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
    })
  }
}
</script>

<style scoped>
  .btn{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .4);
    opacity: 0;
    cursor: pointer;
    transition: all .5s;
    border: 0;
    border-radius: 50%;
    outline: none;
  }
  .btn:hover{
    opacity: 1;
  }
  .xianshi{
    text-align: center;
    font-size: 16px;
    color: white;
    letter-spacing: .1em;
  }
  .xianshi>img{
    width: 22px;
    height: auto;
    display: block;
    margin: 0 auto 10px;
  }
</style>